import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import Layout from "../../../layout";
import Physical from './physical';
import ExportGoods from './ExportGoods';
import NewPhysical from './newPhysical';
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";


let useStyles = makeStyles((theme) => ({
    root: {
        padding: '20px',
        // backgroundColor:'red'
    },
    appBar:{
        backgroundColor:'#0B1742',
        borderRadius:5,
    }
}))




function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
     
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `nav-tab-${index}`,
        "aria-controls": `nav-tabpanel-${index}`
    };
}

function LinkTab(props) {
    return (
        <Tab
            component="a"
            style={{borderRadius:5}}
            onClick={(event) => {
                event.preventDefault();
            }}
            {...props}
        />
    );
}



export default function Index() {

    let classes = useStyles();

    const [valueTab, setValueTab] = useState(0);
    
    const handleChange = (event, newValue) => {
        setValueTab(newValue);
      };



    return (
        <Layout>
            <div className={classes['root']}>
                <NewPhysical />
                {/* <AppBar position="sticky" style={{ zIndex: 0 }}>
                    <Tabs
                        value={valueTab}
                        onChange={handleChange}
                        aria-label="wrapped label tabs"
                        className={classes.appBar}
                    >
                        <LinkTab
                            className={classes["LinkTab"]}
                            label="فیزیکی"
                            href="/"
                            {...a11yProps(0)}
                        />
                        <LinkTab
                            className={classes["LinkTab"]}
                            label="صادراتی"
                            href="/"
                            {...a11yProps(1)}
                        />
                    </Tabs>
                </AppBar>

                <TabPanel value={valueTab} index={0}>
                    <Physical />
                </TabPanel>
                <TabPanel value={valueTab} index={1}>
                    <ExportGoods />
                </TabPanel> */}
            </div>
        </Layout>

    )
}
